import Swiper from 'swiper/dist/js/swiper';
import $ from 'jquery';

import breakpoints from '../helpers/breakpoints';

export default class {
  constructor($c) {
    const container = $c.find('.js-advantages-container');
    const prev = $c.find('.js-advantages-prev');
    const next = $c.find('.js-advantages-next');

    this.swiper = new Swiper(container, {
      navigation: { prevEl: prev, nextEl: next },
      loop: true,
      slidesPerView: 3,
      spaceBetween: 100,
      breakpoints: {
        [breakpoints.mobile]: {
          slidesPerView: 1
        }
      }
    });

    this.swiper.on('slideChange', () => this.updateWaves());
    this.updateWaves();
  }
  updateWaves() {
    const $activeSlide = $(this.swiper.slides[this.swiper.activeIndex]);
    const $activeSlides = $activeSlide.nextAll(':lt(2)').addBack();

    $activeSlides.each((i, slide) => {
      const $slide = $(slide);
      const $trigger = $slide.find('.js-show-icon-trigger');
      const number = i + 1;

      $trigger.data('target', `wave-${number}`);
    });
  }
}
